import { useEffect } from "react";
import { motion, useMotionValue, useScroll, useSpring } from "framer-motion";

export const GrainOverlay = () => <div className="grain-overlay" aria-hidden="true" data-testid="grain-overlay" />;

export const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 28, mass: 0.4 });
  return (
    <motion.div
      data-testid="scroll-progress"
      aria-hidden="true"
      className="fixed top-0 left-0 right-0 h-[3px] z-[80] origin-left bg-gradient-to-r from-violet-500 via-violet-700 to-fuchsia-500"
      style={{ scaleX }}
    />
  );
};

export const CursorGlow = () => {
  const x = useMotionValue(-600);
  const y = useMotionValue(-600);
  const sx = useSpring(x, { stiffness: 55, damping: 18, mass: 0.6 });
  const sy = useSpring(y, { stiffness: 55, damping: 18, mass: 0.6 });

  useEffect(() => {
    const move = (e) => {
      x.set(e.clientX - 280);
      y.set(e.clientY - 280);
    };
    window.addEventListener("mousemove", move, { passive: true });
    return () => window.removeEventListener("mousemove", move);
  }, [x, y]);

  return (
    <motion.div
      data-testid="cursor-glow"
      aria-hidden="true"
      className="fixed top-0 left-0 w-[560px] h-[560px] rounded-full pointer-events-none z-[4] hidden md:block bg-violet-400/[0.10]"
      style={{ x: sx, y: sy, filter: "blur(90px)" }}
    />
  );
};
